let isInitializing = false;
let isInitialized = false;
const loadFormbricksSDK = async (apiHostParam) => {
  if (!globalThis.formbricks) {
    const scriptTag = document.createElement("script");
    scriptTag.type = "text/javascript";
    scriptTag.src = `${apiHostParam}/js/formbricks.umd.cjs`;
    scriptTag.async = true;
    const getFormbricks = async () => new Promise((resolve, reject) => {
      const timeoutId = setTimeout(() => {
        reject(new Error(`Formbricks SDK loading timed out`));
      }, 1e4);
      scriptTag.onload = () => {
        clearTimeout(timeoutId);
        resolve();
      };
      scriptTag.onerror = () => {
        clearTimeout(timeoutId);
        reject(new Error(`Failed to load Formbricks SDK`));
      };
    });
    document.head.appendChild(scriptTag);
    try {
      await getFormbricks();
      return { ok: true, data: void 0 };
    } catch (error) {
      const err = error;
      return {
        ok: false,
        error: new Error(err.message ?? `Failed to load Formbricks SDK`)
      };
    }
  }
  return { ok: true, data: void 0 };
};
const functionsToProcess = [];
const validateSetupArgs = (args) => {
  const argsTyped = args[0];
  const { appUrl, environmentId } = argsTyped;
  if (!appUrl) {
    console.error("🧱 Formbricks - Error: appUrl is required");
    return null;
  }
  if (!environmentId) {
    console.error("🧱 Formbricks - Error: environmentId is required");
    return null;
  }
  return { appUrl, environmentId };
};
const processQueuedFunctions = (formbricksInstance) => {
  for (const { prop: functionProp, args: functionArgs } of functionsToProcess) {
    if (typeof formbricksInstance[functionProp] !== "function") {
      console.error(
        `🧱 Formbricks - Error: Method ${functionProp} does not exist on formbricks`
      );
      continue;
    }
    formbricksInstance[functionProp](...functionArgs);
  }
};
const handleSetupCall = async (args) => {
  if (isInitializing) {
    console.warn(
      "🧱 Formbricks - Warning: Formbricks is already initializing."
    );
    return;
  }
  const validatedArgs = validateSetupArgs(args);
  if (!validatedArgs) return;
  isInitializing = true;
  try {
    const loadSDKResult = await loadFormbricksSDK(validatedArgs.appUrl);
    const formbricksInstance = globalThis.formbricks;
    if (!loadSDKResult.ok || !formbricksInstance) {
      console.error("🧱 Formbricks - Error: Failed to load Formbricks SDK");
      return;
    }
    await formbricksInstance.setup(...args);
    isInitialized = true;
    processQueuedFunctions(formbricks);
  } catch (err) {
    console.error("🧱 Formbricks - Error: setup failed", err);
  } finally {
    isInitializing = false;
  }
};
const executeFormbricksMethod = async (prop, args) => {
  const formbricksInstance = globalThis.formbricks;
  if (!formbricksInstance) return;
  await formbricksInstance[prop](...args);
};
const loadFormbricksToProxy = async (prop, ...args) => {
  if (isInitialized) {
    await executeFormbricksMethod(prop, args);
  } else if (prop === "setup") {
    await handleSetupCall(args);
  } else {
    console.warn(
      "🧱 Formbricks - Warning: Formbricks not initialized. This method will be queued and executed after initialization."
    );
    functionsToProcess.push({ prop, args });
  }
};
const formbricksProxyHandler = {
  get(_target, prop, _receiver) {
    return (...args) => loadFormbricksToProxy(prop, ...args);
  }
};
const formbricks$1 = new Proxy(
  {},
  formbricksProxyHandler
);
export {
  formbricks$1 as default
};
//# sourceMappingURL=index.js.map
